import { createSlice, createEntityAdapter } from '@reduxjs/toolkit';
import { Position } from './types';
import { loadQueue, nextPosition, checkInPosition, checkOutOldestPosition } from './api';

const positionsAdapter = createEntityAdapter<Position>();

export const positions = createSlice({
  name: 'positions',
  initialState: positionsAdapter.getInitialState(),
  reducers: {},
  extraReducers: {
    [loadQueue.fulfilled.type]: (state, action) => {
      if (action.payload.positions) {
        positionsAdapter.upsertMany(state, action.payload.positions);
      }
    },
    [nextPosition.fulfilled.type]: (state, action) => {
      if (action.payload.positions) {
        positionsAdapter.upsertMany(state, action.payload.positions);
      }
    },
    [checkInPosition.pending.type]: (state, action) => {
      positionsAdapter.updateOne(state, {
        id: action.meta.arg.position,
        changes: {
          status: 'fulfilled',
        },
      });
    },
    [checkInPosition.fulfilled.type]: (state, action) => {
      if (action.payload.positions) {
        positionsAdapter.upsertMany(state, action.payload.positions);
      }
    },
    [checkOutOldestPosition.fulfilled.type]: (state, action) => {
      if (action.payload.positions) {
        positionsAdapter.upsertMany(state, action.payload.positions);
      }
    },
  },
});

export const { selectById: selectPositionById } = positionsAdapter.getSelectors();

export default positions.reducer;
